import api from './'

export function remove(id) {
  return api.delete(`/observacao/${id}`)
}